module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point01_06_travel-5f0f526a86b216684eac911768aacff6.jpg";